const WIDGET_STATE_KEY = 'browser_phone_widget_state';

export const readWidgetState = () => {
  try {
    return JSON.parse(window.localStorage.getItem(WIDGET_STATE_KEY) || '{}');
  } catch {
    return {};
  }
};

export const writeWidgetState = state => {
  window.localStorage.setItem(WIDGET_STATE_KEY, JSON.stringify(state));
};

export const clearWidgetState = () => {
  window.localStorage.removeItem(WIDGET_STATE_KEY);
};
